import { Component, Input, OnInit } from '@angular/core';

import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';
import { Classificacao } from '../incidente/classificacao';

import { Router, ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'app-inicio',
  templateUrl: './resumo.component.html',
  styleUrls: ['./resumo.component.css'],
  providers: [ IncidenteService ]
})

export class ResumoComponent implements OnInit {

  incidente_id: number;

  public incidente: Incidente;

  constructor(private incidenteService: IncidenteService, private router: Router, private route: ActivatedRoute) {
    this.incidente = new Incidente();
  }

  getIncidente(): void{
    this.route.params.forEach((params: Params) => {
     let id = params['id']; // id do incidente


    this.incidente_id = id;

    if (id !== undefined) {
         this.incidenteService.getDadosIncidente(id)
         .then((incidente) => {this.incidente = incidente;
        });
    }

   });

  }


  ngOnInit() {
    this.getIncidente();
  }

}



// WEBPACK FOOTER //
// ./src/app/resumo/resumo.component.ts